if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // Aguarda um pouco para garantir que o DOM esteja totalmente carregado
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        // Se não encontrou o carrinho, tenta novamente após um pequeno delay
        if (!this.cart) {
          setTimeout(() => {
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          }, 100);
        }
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.isSubmitting) return;
        this.isSubmitting = true;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const personalizationInput = this.querySelector('[data-personalization-input]');
        const personalizationText =
          personalizationInput && !personalizationInput.disabled ? personalizationInput.value.trim() : '';

        // An empty field must behave exactly like a product without personalization,
        // so the property is kept out of the payload entirely.
        if (personalizationInput && !personalizationText) personalizationInput.disabled = true;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const variantId = formData.get('id');

        // Verifica novamente se o carrinho existe antes de processar
        if (!this.cart) {
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        }

        const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : null;
        if (this.cart) this.cart.setActiveElement(document.activeElement);

        if (personalizationText) {
          config.body = JSON.stringify({
            items: this.buildPersonalizedItems(formData, personalizationText),
            ...(sections ? { sections, sections_url: window.location.pathname } : {}),
          });
        } else {
          delete config.headers['Content-Type'];
          if (sections) {
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Tenta encontrar o cart-drawer novamente antes de redirecionar
              this.cart = document.querySelector('cart-drawer');
              if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
            }

            // A multi-item add returns `items` instead of the single line item that
            // the cart renderers expect to read `key`/`id` from.
            if (response.items && response.key === undefined) {
              const mainItem = response.items.find((item) => `${item.id}` === `${variantId}`) || response.items[0];
              if (mainItem) {
                response.key = mainItem.key;
                response.id = mainItem.id;
              }
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.isSubmitting = false;
            if (personalizationInput) personalizationInput.disabled = false;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      // Builds the main product plus the paid personalization service as a single
      // atomic /cart/add.js payload, so the two lines can never land out of sync.
      buildPersonalizedItems(formData, text) {
        const quantity = parseInt(formData.get('quantity'), 10) || 1;
        const linkId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
        const propertyName = this.personalization.dataset.propertyName;

        const properties = {};
        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') properties[match[1]] = value;
        });
        properties[propertyName] = text;
        properties[PERSONALIZATION_LINK_PROPERTY] = linkId;

        const mainItem = { id: formData.get('id'), quantity, properties };
        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) mainItem.selling_plan = sellingPlan;

        return [
          mainItem,
          {
            id: this.personalization.dataset.variantId,
            quantity,
            properties: {
              [propertyName]: text,
              [PERSONALIZATION_LINK_PROPERTY]: linkId,
            },
          },
        ];
      }

      get personalization() {
        return this.querySelector('product-personalization[data-personalization]');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
